export default function MainContainer({ children }: { children: React.ReactNode }) {
  return <div className="w-full mx-auto max-w-7xl sm:px-2 lg:px-8">{children}</div>;
}
